import { ReactComponent as LoaderIcon } from 'assets/icons/loading.svg';
import DisableWindowScroll from '../DisableWindowScroll/DisableWindowScroll';
import { LoaderProps } from './Loader.types';

import {
  OverlayContainer,
  OverlayIcon,
  LoaderIconWrapper,
  LoaderContainer,
} from './Loader.style';

const Loader = ({
  viewMode,
  overlayViewMode,
  active,
  children,
  className,
  animationDelayMs,
  allowDisableWindowScroll = true,
}: LoaderProps) => {
  return (
    <LoaderContainer viewMode={viewMode} className={className} active={active}>
      {children}
      {active && (
        <OverlayContainer
          active={active}
          overlayViewMode={overlayViewMode}
          animationDelayMs={animationDelayMs}
        >
          {overlayViewMode === 'fullscreen' && allowDisableWindowScroll && (
            <DisableWindowScroll />
          )}
          <OverlayIcon>
            <LoaderIconWrapper
              iconSize={'6rem'}
              svgIconComponent={LoaderIcon}
            />
          </OverlayIcon>
        </OverlayContainer>
      )}
    </LoaderContainer>
  );
};

export default Loader;
